// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "node_modules_web-vitals_dist_web-vitals_js") return "static/js/" + chunkId + ".chunk.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + ".bundle.js";
};